export const t = {
  en: {
    copyToClipboard: 'Copied!',
    share: 'Share article',
  },
  fr: {
    copyToClipboard: 'Copié !',
    share: 'Partager l’article',
  },
  es: {
    copyToClipboard: 'Copiado!',
    share: 'Compartir el artículo',
  },
};
